<template>
  <input-type-ahead
    :list="counselors"
    :value="value"
    :searchchange="getCounselors"
    :selected-value="(val) => $emit('input', val)"
    placeholder="Search for a Counselor..."
    label="Counselor"
    option-value="id"
    option-text="display_label"
  />
</template>

<script>
import InputTypeAhead from '@/components/inputs/InputTypeAhead.vue';
import AdminClient from '@/api/AdminClient';

export default {
  name: "CounselorLookupInput",
  components: {
    InputTypeAhead,
  },
  props: {
    value: {
      type: Number,
      require: true,
    }
  },
  data(){
    return {
      adminClient: new AdminClient(this.$http),
      counselors: [],
      timeout: null,
    }
  },
  methods: {
    getCounselors(query) {
      if(this.value && !query)
        return;
        
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.timeout = setTimeout(async () => {
        const searchCriteria = [];
        for(const split of query.split(/\s/)) {
          if(split)
           searchCriteria.push(split);
        }

        try {
          const response = await this.adminClient.getAllCounselorsByLookup(searchCriteria);
          this.counselors = (response.counselors || []).map(x => ({
            display_label: x.firstName + ' ' + x.lastName + ' (' + x.email + ')', 
            id: x.id
          }))
        } catch(ex) {
          console.error(ex);
          this.counselors = [];
        } finally {
          this.loading = false;
        };
      }, 300);
    },
  },
}
</script>

<style>

</style>